export const walletInfo = {
  from: "From",
  to: "To",
  validBalance: "Valid Balance",
  totalCredit: "Total Credit",
  totalHoldBalance: "Total Hold Balance",
  totalBalance: "Total Balance",
  topupCash: "Topup Cash",
  topupCredit: "Topup Credit",
  withdrawCash: "Withdraw Cash",
  withdrawCredit: "Withdraw Credit",
  cashWallet: "CASH_WALLET",
  balance: "Balance",
  hold: "Hold",
  addCash: "Add Cash",
  creditWallet: "CREDIT_WALLET",
  addCredits: "Add Credits",
  topupCash: "Topup Cash",
  creditAmount: "Credit Amount",
  topup: "Topup",
  cash: "Cash",
  credit: "Credit",
  withdraw: "Withdraw",
  totalWithdraw: "Total Withdraw",
  totalDeposit: "Total Deposit",
  topupCredit: "Topup Credit",
  cancel: "Cancel",
  wallet: "Wallet",
  topupCash: "Topup Cash",
  clear: "Clear",
  creditNote: "Note",
  turnoverLeft: "Turnover Left",
  adjustTurnOver: "Adjust Turnover",
  adjustTurnoverLeft: "Adjust Turnover Left",
};
